// extracted by mini-css-extract-plugin
export default {"home":"c-i_cn","home__background":"c-i_co","home__content":"c-i_cp"};